import type { WorkBlock } from "../../domain/operations";

export function TimeRail({ block }: { block: WorkBlock }) {
  return <div className="time-rail"><span>{block.label}</span><strong>{block.time}</strong><small>{block.meridiem}</small></div>;
}
